import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PollSelectComp = ({ mapArray }) => {
  console.log("🚀 ~ PollSelectComp ~ mapArray:", mapArray)
  // console.log("🚀 ~ PollSelectComp ~ mapArray:", mapArray)
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  // console.log("mapArray", mapArray);

  return (
    <div>
      <div className="my-2 grid grid-cols-1 min-[380px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2">
        {mapArray?.map((res) => {
          const isHovered = hoveredId === res.id;
          return (
            <div
              key={res?.id}
              className="m-auto  min-[380px]:m-0 size-[160px] hover:bg-white bg-[#F7F8FA] hover:border-2 border-red-500 cursor-pointer rounded-xl flex justify-center items-center flex-col overflow-hidden object-contain"
              onClick={() => {
                navigate(res?.url);
                localStorage.setItem("state", res?.id);
                localStorage.setItem("country", res?.countryId);
              }}
              onMouseEnter={() => setHoveredId(res?.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              {/* {console.log("res", res)} */}
              <img
                src={isHovered ? res?.hoverMap : res?.map}
                alt="country-flag"
                width={90}
                className="object-contain size-24"
              />
              <p className="mt-5 text-[12px] font-semibold capitalize text-center">
                {res?.name} Polls
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PollSelectComp;
